<script>
import Vue from 'vue'
import DibbleJS from "@/dibble";
import DibbleTranslation from "@/translation/translation";
import {EventBus} from "@/utils/event-bus";

Vue.use(require('vue-cookies'));

export default {
    name: "Header",
    data() {
        return {
            translate: DibbleTranslation,
            dibbleJs: DibbleJS,
            items: [],
            userAuth: null,
            isMapEnabled: false,
            logoUrl: '',
        }
    },
    created() {
        this.logoUrl = localStorage.getItem('fund_logo');
        EventBus.$on('update-logo', (logoUrl) => {
            this.logoUrl = logoUrl;
        });
    },
    methods: {}
}
</script>
<template src="./template/index.html"></template>
<style scoped>
.container {

}
img.header-left-logo {
  width: auto;
  height: 86px;
}

@media (max-width: 768px) {
  img.header-left-logo {
    height: 50px;
  }
}

@media (max-width: 576px) {
  img.header-left-logo {
    height: 40px;
  }
}
</style>
